import React from 'react';

interface ContainerProps {
    children: React.ReactNode;
    style?: React.CSSProperties;
    wide?: boolean;
}

const Container: React.FC<ContainerProps> = ({ children, style, wide }) => {
    return <div style={{ margin: wide ? '50px' : '20px', ...style }}>{children}</div>;
};

export default Container;
